import { graphql, HttpResponse } from 'msw'
import { type EnrollmentAccountNameV2Data, type EnrollmentAccountNameV2SubmitOutput } from '../../../../../models'

export const getEnrollmentAccountNameV2DataMock: EnrollmentAccountNameV2Data = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/account-name/traditional-inherited',
  enrollmentData: {
    applicationId: '1234567890',
    recommendation: {
      investment: {
        account: {
          accountNickname: 'Investment Account',
        },
      },
    },
  },
}

export const submitEnrollmentAccountNameV2DataMock: EnrollmentAccountNameV2SubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/confirm-personal-info',
  enrollmentData: {
    recommendation: {
      investment: {
        account: {
          accountNickname: 'Investment Account',
        },
      },
    },
  },
}

export const mockGetEnrollmentAccountNameV2Data = graphql.mutation('getEnrollmentAccountNameV2Data', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentAccountNameV2DataMock } })
})

export const mockSubmitEnrollmentAccountNameV2Data = graphql.mutation('submitEnrollmentAccountNameV2Data', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentAccountNameV2DataMock } })
})

export const mockEnrollmentAccountNameV2 = [mockGetEnrollmentAccountNameV2Data, mockSubmitEnrollmentAccountNameV2Data]
